<template>
    <div>

        <section id="signin">

            <div class="columns mt0 mb0 pb0">

                <div class="column fullcol is-7 is-hidden-touch">
                    <div class="loginbg" :style="'background-image:url(\'/static/images/signin/Imagem'+rdm+'.jpg\')'">

                        <p class="loginbg-txt">
                            O FACILIMO É A PLATAFORMA QUE <br>
                            AJUDA A REALIZAR PROJECTOS
                        </p>


                        <div class="loginbgsocial">
                            <p>
                                SIGA-NOS
                            </p>
                            <p>
                               <i class="fa fa-facebook-square"></i>
                               <i class="fa fa-instagram"></i>
                               <i class="fa fa-linkedin-square"></i>
                            </p>

                        </div>


                    </div>

                </div>

                <div class="column fullcol is-5-desktop" id="rightcol" style="background-color: #f1f1f1; display:flex; flex-direction:column;">


                    <div class="formcontainer" style="height:100%;">


                        <div class="loginaction">



                            <div class="loginlogo" @click="$router.push({path:'/'})" style="cursor:pointer;">
                                <img src="/static/images/layout/logotop.png" alt="FACILIMO">
                            </div>

                            <div id="signinflow">

                                <transition name="fade">

                                    <div id="flow-step-1">

                                        <p id="aceda">ACEDA À SUA CONTA</p>
	                                    <p v-if="disabled" style="padding:1rem 0; font-size:0.8rem;font-weight:300; text-align: left" class="has-text-primary pt0"><em>O seu registo está inativo. Por favor consulte o nosso suporte.</em></p>
	                                    <p v-if="success" style="padding:1rem 0; font-size:0.8rem;font-weight:300; text-align: left" class="has-text-success pt0"><em>{{success}}</em></p>


	                                    <div class="step1container">

                                            <form>

                                                <div class="columns">
                                                    <div class="column ">
                                                        <input :class="{'badinput': errors.has('email')}" class="formfield" type="text" name="email" data-vv-as="e-mail" v-model="email" v-validate="'required|email'" placeholder="E-mail">
                                                    </div>
                                                </div>

                                                <div class="columns">
                                                    <div class="column">
                                                        <div :class="{'badinput': errors.has('password')}" style="border:solid 1px white" class="field has-addons">
                                                            <input style="border:none" class="formfield" :type="hide ? 'password' : 'text'" name="password" data-vv-as="password" v-model="password" v-validate="'required|min:8'" placeholder="Password" >
                                                            <div class="control is-expanded">
                                                                <a class="button" style="border:none;height:100%" @click="hide = !hide">
                                                                    <transition name="fade">
                                                                        <i v-if="hide" class="fa fa-eye" ></i>
                                                                        <i v-if="!hide" class="fa fa-eye-slash" ></i>
                                                                    </transition>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="columns">
                                                    <div class="column">
                                                        <p  style="font-size: 0.85rem;" class="mb0 pb0">

                                                            <router-link to="esqueci" class="loginprompt">Esqueceu-se da Password?</router-link>

                                                        </p>
	                                                    <p  style="font-size: 0.85rem;">

                                                            <router-link to="esqueci" class="loginprompt">Tem conta mas ainda não definiu a sua Password?</router-link>

                                                        </p>
                                                    </div>


                                                </div>

                                                <transition>
                                                    <p v-if="!disabled" style="padding:1rem 0; font-size:0.8rem;font-weight:300;" class="has-text-primary"><em>{{error ? error : ''}}&nbsp;</em></p>
                                                </transition>

                                                <div class="procceed">
                                                    <input type="submit" class="button is-primary" @click.prevent="signin" style="margin:0; font-weight: 600; line-height: 0;
font-family: inherit;" value="INICIAR SESSÃO">
                                                    <p class="loginprompt">Não tem conta? <router-link to="registo" class="loginprompt">Registe-se aqui</router-link></p>
                                                </div>

                                            </form>


                                        </div>

                                    </div>

                                </transition>

                            </div>



                            <div class="procceed" style="margin-top: 0;" >
                               <!-- <a class="button fbbut" @click="buttonClicked"
                                   style="
                                    margin:0;
                                    margin-top:0.5rem;
                                    border: solid 1px #4267b2;
                                    color:white;
                                    background-color:#4267b2;
                                    padding: 11px 8px;
                                    font-size: 14px;
                                    height:40px;
                                    line-height:18px;
                                    font-weight: 500;
                                    border-radius:2px;
                                    width:20rem;
" >
                                    <i class="fa fa-facebook-square fa-lg" style="margin-right:18px;"></i>
                                    Login com Facebook
                                </a>-->




                                <a class="button" @click="googleSignIn" style="
                                margin:0;
                                margin-top:0.5rem;
                                border: solid 1px rgba(0,0,0,0.54);
                                color:rgba(0,0,0,0.54);
                                background-color:#ffffff;
                                padding: 11px 8px;
                                font-size: 14px;
                                height:40px;
                                line-height:18px;
                                font-weight: 500;
                                border-radius:2px;
                                width:20rem;
                                ">
                                    <img src="/static/images/signin/g-logo.png" style="height:18px;margin-right: 18px;"/>
                                    Login com Google

                                </a>

                              <!--  <div id="googleButton"></div>-->

                            </div>

                        </div>

                    </div>



                </div>

            </div>

        </section>

        <transition name="fade">
            <div class="modal" :class="{'is-active': loading}">
                <div class="modal-background" style="background-color: rgba(10, 10, 10, 0.50);">

                    <i class="fa fa-spinner fa-pulse fa-3x" style="position: absolute;top: 50%;left: 50%;"></i>

                </div>

            </div>
        </transition>

    </div>

</template>

<script>
import { mask } from "vue-the-mask";
import { apiUrl } from "../vars";
import { appUrl } from "../vars";
import auth from "../auth";
import { removeChatMixin } from "../plugins/removeChatMixin";
import { notificationMixin } from "../plugins/notificationMixin";
import VueScript2 from "vue-script2";
import {
  loadFbSdk,
  getFbLoginStatus,
  fbLogout,
  fbLogin
} from "../plugins/facebook";
import { google } from "../vars";

export default {
  mixins: [removeChatMixin, notificationMixin],

  data() {
    return {
      loading: false,
      email: null,
      password: null,
      hide: true,
      rdm: 1,
        disabled: false,
	    success: null,

      //Google login
      auth2: null,
      gapi: null,

      //Facebook login
      isConnected: false,
      appId: 1776286176001743,
      version: "v2.12"
    };
  },

  created() {
    this.rdm = Math.ceil(Math.random() * 3);

    if (this.$route.params.phone) {
	   this.success = "O seu número de telemóvel foi verificado com sucesso.";
    }

    //	        let signout = this.$route.query.signout;
    //	        if (signout) {
    //	        	auth.signout(this);
    //            }

    let that = this;

    VueScript2.load("https://apis.google.com/js/platform.js").then(function() {
      gapi.load("auth2", function() {
        that.auth2 = gapi.auth2.init({
          client_id: google.clientId,
          fetch_basic_profile: true
        });
      });
      that.gapi = gapi;
    });

    loadFbSdk(this.appId, this.version)
      .then(getFbLoginStatus)
      .then(response => {
        if (response.status === "connected") {
          this.isConnected = true;
        }
        this.isWorking = false;
        /** Event `get-initial-status` to be deprecated in next major version! */
        this.$emit("get-initial-status", response);
        this.$emit("sdk-loaded", {
          isConnected: this.isConnected,
          FB: window.FB
        });
      });
  },

  computed: {
    googleAvailable() {
      return this.gapi && this.auth2;
    }
  },

  methods: {
    login() {
      fbLogin({ scope: "email" }).then(response => {
        if (response.status === "connected") {
          this.isConnected = true;
        } else {
          this.isConnected = false;
        }
        this.$emit("login", {
          response,
          FB: window.FB
        });
      });
    },

    buttonClicked() {
      this.$emit("click");
      this.login();
    },

    googleSignIn() {
      let that = this;
      // Sign the user in, and then retrieve their ID.
      this.auth2.signIn().then(function(response) {
        that.onSignIn();
      });
    },

    googleSignOut() {
      let that = this;
      // Sign the user in, and then retrieve their ID.
      this.auth2.signOut().then(function() {
        console.log("signed out");
      });
    },

    onSignIn() {
      let u = this.auth2.currentUser.get();
      let id_token = u.getAuthResponse().id_token;

      if (u) {
        let profile = u.getBasicProfile();
        let name = profile.getName();
        //console.log('Image URL: ' + profile.getImageUrl());
        let email = profile.getEmail();

        axios
          .post(apiUrl + "/auth/google/token", {
            id_token: id_token,
            email: email
          })
          .then((response, context = this) => {
            if (response.data.newuser) {
              context.$router.push({
                name: "signup",
                params: {
                  email: email,
                  name: name,
                  p1: response.data.p1
                }
              });
              return;
            }

            if (response.data.token) {
              context.error = null;
              let token = response.data.token;

              let d = "home";
              let t = token.split(".");
              let i = btoa(t[0])
                .split("")
                .reverse()
                .join("");
              let w = btoa(response.statusText);
              let v = btoa(response.message);
              let u = btoa(t[1])
                .split("")
                .reverse()
                .join("");
              let k = btoa(response.data.status);
              let r = btoa(t[2])
                .split("")
                .reverse()
                .join("");
              let x = btoa(d);
              console.log("go");

              window.location =
                appUrl +
                "/sso?gw328DK2=" +
                i +
                "&ADHXf2x3=" +
                w +
                "&xftBIGAC=" +
                v +
                "&BGxYZ4xu=" +
                u +
                "&PeIQ306e=" +
                k +
                "&o2d8IWFA=" +
                r +
                "&bPkIzKkT=" +
                x;
            }

            if (response.data.invalid) {
              context.error = "Erro ao validar as credenciais.";
            }
          });
      }
    },

    signin() {
      let o = {
        email: this.email.toLowerCase(),
        password: this.password
      };
      console.debug(o.email)
      console.log("create ok");
      auth.signin(this, o);
    }
  },

  watch: {}
};
</script>

<style scoped lang="scss">
.signup {
  padding: 1rem 2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.button2 {
  margin-left: 1rem;
  font-size: 0.8rem;
  padding: 1.2rem 1rem;
  font-weight: 700;
}

.button2:hover {
  background-color: white !important;
}

#signin {
  position: relative;
}

#signin .columns {
  position: relative;
}

#signin .fullcol {
  position: relative;
  min-height: 100vh;
  max-height: 100vh;
  padding: 0;
}

.loginbg {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  position: relative;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.loginbg-txt {
  text-align: center;
  font-size: 1.35rem;
  color: white;
  font-weight: 600;
  line-height: 1.2;
}

.loginbgsocial {
  text-align: center;
  padding: 4rem 0 2rem;
}

.loginbgsocial p {
  text-align: center;
  color: #e90054;
  font-size: 0.9rem;

  font-weight: 600;
}

.loginbgsocial i {
  text-align: center;
  font-size: 1.15rem;
  color: white;
  padding: 0.3rem;
  font-weight: 500;
}

.loginaction {
  background-color: #f1f1f1;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.loginlogo {
  padding: 4.5rem 0 0;
}

#aceda {
  margin-top: 4rem;
  color: #2d3256;
  font-weight: 600;
  text-align: left;
  padding: 1rem 0;
  font-size: 1.2rem;
}

.step1container {
  padding: 1rem 0;
}

.loginprompt {
  margin-top: 1rem;
  color: #848a96;
  font-size: 0.8rem;
}

.loginprompt {
  color: #e90054;
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.8rem;
}

form .column {
  padding: 0.3rem;
}

.loginlogo img {
  height: 3rem;
}

.formfield {
  //border: solid 1px #848a96;
  background-color: white;
  padding: 0.5rem;
  width: 100%;
  font-size: 0.9rem;
}

.fbbut {
  border: none;
  margin: 0.1rem;
  justify-content: center;
  padding-left: 1rem;
  padding-right: 1rem;
}

.fbbut:hover {
  border: none;
}

.gobut {
  border: none;
  margin: 0.1rem;
  justify-content: left;
  padding-left: 1rem;
  padding-right: 1rem;
}

.gobut:hover {
  border: none;
}

.procceed {
  text-align: center;
  padding: 0 0 4.5rem;
}

.procceed .button {
  padding: 1.25rem 3rem;
  font-size: 0.85rem;
  margin: 1rem;
}

.formcontainer {
  margin: auto;
  margin-bottom: 6rem;
  max-width: 20rem;
  min-width: 20rem;
}

input {
  border: solid 1px #f1f1f1;
}

.badinput {
  border: solid 1px #e90054 !important;
}

@media screen and (max-width: 768px) {
  #rightcol {
    overflow-y: auto;
  }
}

@media screen and (max-height: 570px) and (min-width: 769px) {
  #rightcol {
    overflow-y: auto;
  }
}

@media screen and (max-height: 720px) {
  .procceed {
    margin-top: 2rem;
    text-align: center;
    padding: 0 0 2rem;
  }

  .loginlogo {
    padding: 3rem 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Signin.vue